/*
 *
 * Dashboard action/reducer
 *
 */

import { createSlice } from "@reduxjs/toolkit";
import {
  getTnCForCidpUser,
  goToSecuritySettings,
  removeToken,
  setUserAcceptedNewTnC,
} from "scenes/redux";
import { createActionDispatchers } from "utils/reduxHelpers";

export type State = {};

export const initialState: State = {};

const slice = createSlice({
  name: "dashboard",
  initialState,
  // create actions with reducer (slice action) here
  reducers: {},
  // reducer for external action
  // extraReducers: (builder) => {
  //   builder.addCase(externalAction, (state) => {
  //   });
  // },
});

/**
 * actions from slice to be exported for saga
 */

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  // slice actions
  [],
  // pure actions
  {
    removeToken,
    goToSecuritySettings,
    getTnCForCidpUser,
    setUserAcceptedNewTnC,
  }
);

export default slice.reducer;
